import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TapestryButtonModule } from '@predictiveindex/tapestry';
import { TranslationsModule } from '../../../translations';
import { GlobalSearchInspireCtaComponent } from './global-search-inspire-cta.component';

@NgModule({
    declarations: [GlobalSearchInspireCtaComponent],
    imports: [CommonModule, TranslationsModule, TapestryButtonModule],
    exports: [GlobalSearchInspireCtaComponent]
})
export class GlobalSearchInspireCtaModule {
    constructor() {}
}
